import scrollMonitor from 'scrollmonitor'

export default () => {
  const monitor = document.querySelector('.js-sticky-share-container') // sticky-share.twig
  const sticky = document.querySelector('.js-sticky-share')
  const end_monitor = document.querySelector('.js-sticky-end') // post-footer.twig

  if (! monitor || ! end_monitor) return

  console.log(`scrollmonitor`)

  const watcher = scrollMonitor.create(monitor, 0)
  const bottom_watcher = scrollMonitor.create(end_monitor, -100)

  watcher.enterViewport(() => {
    sticky.classList.remove('active')

    console.log(`remove active 1`)
  })

  watcher.stateChange(() => {
    if (watcher.isAboveViewport) {
      sticky.classList.add('active')

      console.log(`add active 1`)
    } else {
      sticky.classList.remove('active')

      console.log(`remove active 2`)
    }
  })

  bottom_watcher.enterViewport(() => {
    sticky.classList.remove('active')

    console.log(`remove active 3`)
  })

  bottom_watcher.stateChange(() => {
    if (bottom_watcher.isBelowViewport) {
      sticky.classList.add('active')

      console.log(`add active 2`)
    }
  })

}


// WEBPACK FOOTER //
// ./src/js/modules/StickyShare.js